import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as Cookies from 'js-cookie';
import { OrderDetailsModel, ProductModel, OrderDetailResponseModel } from '@/components/OrderDetails/orderdetails.model';
import { LoginTokenModel } from '@/components/Login/login.model';


Vue.use(Vuex);

const initialState =()=>{
  return new OrderDetailResponseModel();
}

const loginInitialState = () => {
  return new LoginTokenModel();
}

export default new Vuex.Store({

  state: {
      orderDetails: initialState(),
      loginState: loginInitialState(),
      isLoggedIn: false,
      isAdmin: false,
      username: '',
      token: '',
      email: ''
  },
  mutations: {
    ADD_ORDER_DETAILS(state,payload:any){
      state.orderDetails = payload;
    
    },
    ADD_LOGIN_TOKEN(state,payload:any){
      
      state.loginState = payload;
      state.email = payload.email;
      state.token = payload.token;
      state.username = payload.username;
      state.isAdmin = payload.is_admin;
      localStorage.setItem("isAdmin",payload.is_admin);
      localStorage.setItem("email",payload.email);
      localStorage.setItem("username",payload.username);
      localStorage.setItem("token",payload.token);
      state.isLoggedIn = true;
      localStorage.setItem("isLoggedIn",'true');
    },
    CHANGE_LOGGEDIN_STATUS(state){
      if(state.isLoggedIn === false){
        state.isLoggedIn = true;
      }else{
        state.isLoggedIn = false;
      }
    },
    LOGOUT(state){
      state.email = '';
      state.token = '';
      state.username = '';
      state.isLoggedIn = false;
      state.isAdmin = false;
      console.log("LOGOUT STORE");
      localStorage.removeItem("email");
      localStorage.removeItem("username");
      localStorage.removeItem("token");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("isAdmin");     
    } 
  },
  actions: {
    addOrderDetails(context, order) {
      context.commit("ADD_ORDER_DETAILS", order);
    },
    addLoginToken(context, token){
      context.commit("ADD_LOGIN_TOKEN", token);
    },
    changeLoggedInStatus(context){
      context.commit("CHANGE_LOGGEDIN_STATUS");
    },
    logOut(context){
 
      context.commit("LOGOUT");
    }
  },
  getters:{
    getOrderDetails(state){
      return state.orderDetails;
    },
    getLoginToken(state){
      return state.loginState;
    },
    getLoginStatus(state){
      return state.isLoggedIn;
    },
    getAdminStatus(state){
      
      return state.isAdmin;
    }
  },
});

